import { render, staticRenderFns } from "./MembershipMessages.vue?vue&type=template&id=ded2baa4&scoped=true"
import script from "./MembershipMessages.vue?vue&type=script&lang=js"
export * from "./MembershipMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ded2baa4",
  null
  
)

export default component.exports